import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { apiGet, type AppConfig } from "@/shared/api";

/** Query key for the signed-in user's configuration. */
export const APP_CONFIG_KEY = ["config"] as const;

/**
 * Fetches `/api/config`.
 *
 * This is the app's first authenticated call, so it doubles as the sign-in
 * probe: a 401 here is what tells us IAP wants the browser to re-authenticate.
 */
export function useAppConfig(): UseQueryResult<AppConfig, Error> {
  return useQuery({
    queryKey: APP_CONFIG_KEY,
    queryFn: () => apiGet<AppConfig>("/config"),
  });
}
